import { DASHBOARD_DATA } from "../types";

export const DashBoardReducer = (state = {}, action) => {
	const { type, payload } = action;

	switch (type) {
		case DASHBOARD_DATA: {
			const { data } = payload;
			return data;
		}
		default: {
			return state;
		}
	}
};
